/* ============================================================
   TAO WEARING — Product page (PDP) interactions
   New file (update-safe). Drives the custom buy panel:
   - variant selection -> updates Horizon's hidden input[name="id"], price,
     add-to-cart button, gallery image, and the URL ?variant param.
   - gallery thumbnails, quantity stepper, accordion.
   Add-to-cart itself + the cart drawer are handled by Horizon's
   <product-form-component> (which reads input[name="id"]).
   ============================================================ */
(function () {
  'use strict';

  document.querySelectorAll('[data-tao-product]').forEach(function (root) {
    if (root._taoProduct) return;
    root._taoProduct = true;

    /* ---------- data ---------- */
    var dataEl = root.querySelector('[data-tao-product-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-tao-price]');
    var addBtn = root.querySelector('[data-tao-add]');
    var addLabel = root.querySelector('[data-tao-add-label]');
    var galleryMain = document.querySelector('[data-tao-gallery-main]');

    var optGroups = Array.prototype.slice.call(root.querySelectorAll('[data-tao-opt]'))
      .sort(function (a, b) { return (+a.dataset.optPosition) - (+b.dataset.optPosition); });

    function selectedOptions() {
      return optGroups.map(function (g) {
        var checked = g.querySelector('input[data-tao-radio]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    // is there an AVAILABLE variant with `val` at option index gi, matching the
    // currently-selected values at every other option?
    function valueAvailable(gi, val, sel) {
      return variants.some(function (v) {
        if (!v.available) return false;
        if (v.options[gi] !== val) return false;
        for (var i = 0; i < sel.length; i++) { if (i !== gi && v.options[i] !== sel[i]) return false; }
        return true;
      });
    }

    function update() {
      var opts = selectedOptions();
      var v = findVariant(opts);

      // per-option: selected value label, selected + unavailable states
      optGroups.forEach(function (g, gi) {
        var checked = g.querySelector('input[data-tao-radio]:checked');
        var valEl = g.querySelector('[data-tao-opt-val]');
        if (valEl && checked) valEl.textContent = checked.value;
        g.querySelectorAll('[data-tao-value]').forEach(function (label) {
          var inp = label.querySelector('input[data-tao-radio]');
          if (!inp) return;
          label.classList.toggle('is-selected', inp.checked);
          label.classList.toggle('is-unavailable', !valueAvailable(gi, inp.value, opts));
        });
      });

      if (!v) return;

      // hidden variant id (read by Horizon's product-form-component on submit)
      if (idInput) idInput.value = v.id;

      // price (store currency). Also refresh data for the currency converter,
      // snapshot it as the restore base, then re-apply the chosen currency.
      if (priceEl) {
        var html = '<span class="tao-pdp__now">' + v.price + '</span>';
        if (v.compare_at && v.compare_at !== v.price) {
          html += '<s>' + v.compare_at + '</s>';
        }
        priceEl.innerHTML = html;
        priceEl.setAttribute('data-amount', v.amount);
        priceEl.setAttribute('data-compare', v.compare_amount || 0);
        priceEl._taoBase = html;
        if (window.TaoApplyCurrency) window.TaoApplyCurrency(priceEl);
      }

      // add-to-cart button state + label
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? ('Add to bag — ' + v.price) : 'Sold out';
      }

      // gallery image for this variant
      if (galleryMain && v.media_src) {
        galleryMain.style.opacity = '0';
        setTimeout(function () { galleryMain.src = v.media_src; galleryMain.style.opacity = '1'; }, 160);
      }

      // keep the URL in sync so deep links + Horizon agree on the variant
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      } catch (e) {}

      // broadcast the current price (minor units) for the currency converter
      root.dispatchEvent(new CustomEvent('tao:variant', { bubbles: true, detail: { amount: v.amount } }));
    }

    optGroups.forEach(function (g) {
      g.addEventListener('change', update);
    });
    update();

    /* ---------- add-to-cart click feedback (check animation) ---------- */
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        addBtn.classList.add('is-loading');
        clearTimeout(addBtn._taoLoad);
        addBtn._taoLoad = setTimeout(function () { addBtn.classList.remove('is-loading'); }, 4000);
      });
      document.addEventListener('cart:update', function () {
        if (!addBtn.classList.contains('is-loading')) return;
        clearTimeout(addBtn._taoLoad);
        addBtn.classList.remove('is-loading');
        addBtn.classList.add('is-added');
        if (addLabel) addLabel.textContent = 'Added to bag ♥';
        clearTimeout(addBtn._taoAdded);
        addBtn._taoAdded = setTimeout(function () {
          addBtn.classList.remove('is-added');
          update();
        }, 1900);
      });
      document.addEventListener('cart:error', function () {
        clearTimeout(addBtn._taoLoad);
        addBtn.classList.remove('is-loading');
      });
    }

    /* ---------- gallery thumbnails ---------- */
    document.querySelectorAll('[data-tao-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        if (galleryMain && src) {
          galleryMain.style.opacity = '0';
          setTimeout(function () { galleryMain.src = src; galleryMain.style.opacity = '1'; }, 160);
        }
        document.querySelectorAll('[data-tao-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    /* ---------- quantity stepper ---------- */
    var qtyInput = root.querySelector('[data-tao-qty]');
    var qtyVal = root.querySelector('[data-tao-qty-val]');
    function setQty(n) {
      n = Math.max(1, n);
      if (qtyInput) qtyInput.value = n;
      if (qtyVal) qtyVal.textContent = n;
    }
    var minus = root.querySelector('[data-tao-qty-minus]');
    var plus = root.querySelector('[data-tao-qty-plus]');
    if (minus) minus.addEventListener('click', function () { setQty((+qtyInput.value || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { setQty((+qtyInput.value || 1) + 1); });

    /* ---------- accordion ---------- */
    root.querySelectorAll('[data-tao-acc-item]').forEach(function (item) {
      var btn = item.querySelector('[data-tao-acc-btn]');
      var panel = item.querySelector('[data-tao-acc-panel]');
      var inner = panel ? panel.firstElementChild : null;
      function setH() { if (panel && inner) panel.style.height = item.classList.contains('is-open') ? inner.offsetHeight + 'px' : '0px'; }
      if (item.classList.contains('is-open')) setH();
      if (btn) btn.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        root.querySelectorAll('[data-tao-acc-item]').forEach(function (o) {
          if (o !== item) { o.classList.remove('is-open'); var p = o.querySelector('[data-tao-acc-panel]'); if (p) p.style.height = '0px'; }
        });
        item.classList.toggle('is-open', !open);
        setH();
      });
      window.addEventListener('resize', setH);
    });

    /* ---------- size guide modal ---------- */
    var sg = root.querySelector('[data-tao-sizeguide]');
    if (sg) {
      root.querySelectorAll('[data-tao-sizeguide-open]').forEach(function (b) {
        b.addEventListener('click', function () { if (sg.showModal) sg.showModal(); else sg.setAttribute('open', ''); });
      });
      sg.querySelectorAll('[data-tao-sizeguide-close]').forEach(function (b) {
        b.addEventListener('click', function () { sg.close(); });
      });
      sg.addEventListener('click', function (e) { if (e.target === sg) sg.close(); });
    }
  });
})();
